import Enum from "../../../../class/Enum"

export default Enum.make(["BUSINESS", "ORGANIZATION", "SOLETRADER"]);
